module.exports = __webpack_public_path__ + "img/lilly.53c4aa79.png";